import { Classification } from "@/src/models/constants/classifications";
import { FileType } from "@/src/models/file";
import { Patient } from "@/src/models/patient";
import { Section } from "@/src/models/section";
import { Task } from "@/src/models/task";

/**
 * NOTE:
 * If this is an intake task there may be more than one patient in the task.
 * We prefer the patient from a referral section when multiple sections have patient data.
 * @param task
 * @returns
 */
export function getResolvedPatientForDisplay(task: Task): Patient | null {
  const inboundFile = task.files?.find((file) => file.type === FileType.INBOUND);
  const sections = inboundFile?.sections ?? [];

  if (task.patient) {
    return task.patient;
  }

  const sectionPatients: { section: Section; patient: Patient }[] = sections
    .map((s) => ({ section: s, patient: s.reviewedContent?.patient }))
    .filter((entry): entry is { section: Section; patient: Patient } => {
      const p = entry.patient;

      return !!p && !!(p.givenName || p.familyName);
    });

  const referralSectionPatient = sectionPatients.find(
    ({ section }) => section.classification === Classification.REFERRAL
  );

  if (referralSectionPatient) return referralSectionPatient.patient;

  return sectionPatients[0]?.patient ?? null;
}
